import { render, staticRenderFns } from "./R07.vue?vue&type=template&id=7ac06910&scoped=true"
import script from "./R07.vue?vue&type=script&lang=js"
export * from "./R07.vue?vue&type=script&lang=js"
import style0 from "./R07.vue?vue&type=style&index=0&id=7ac06910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac06910",
  null
  
)

export default component.exports